(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  function restart(el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function readData(box) { if (!box._d) { try { box._d = JSON.parse($('.ev-kv-data', box).textContent); } catch (e) { box._d = null; } } return box._d; }

  /* ---------- Produktkort ---------- */
  function initCard(box) {
    if (box.dataset.evInit) return; box.dataset.evInit = '1';
    var card = box.closest('.js-product-card') || box.parentNode;
    var d = readData(box); if (!d) return;
    var btn = card.querySelector('.js-grid-cart');
    if (btn) {
      var t = btn.querySelector('span:not(.product-card__loading)') || btn;
      t.textContent = d.si > -1 ? 'Välj storlek' : 'Välj variant';
      btn.classList.remove('disabled'); btn.classList.add('ev-kv-pick');
    }
    var img = card.querySelector('.product-card__image img');
    box.addEventListener('click', function (e) {
      var dot = e.target.closest('.ev-kv-dot'); if (!dot) return;
      e.preventDefault(); e.stopPropagation();
      box.querySelectorAll('.ev-kv-dot').forEach(function (x) { x.classList.toggle('is-on', x === dot); });
      box.dataset.color = dot.dataset.val;
      var v = d.v.find(function (x) { return x.o[d.ci] === dot.dataset.val && x.i; });
      if (v && img) swapCardImage(img, v.i);
    });
  }
  function swapCardImage(img, src) {
    if (img.dataset.evSrc === src) return; img.dataset.evSrc = src;
    var wrap = img.parentNode, pre = new Image();
    pre.onload = function () {
      if (img.dataset.evSrc !== src) return;
      var f = document.createElement('img'); f.className = 'ev-kv-fade'; f.alt = ''; f.src = src;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.appendChild(f);
      requestAnimationFrame(function () { requestAnimationFrame(function () { f.classList.add('is-in'); }); });
      setTimeout(function () { img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = src; setTimeout(function () { f.remove(); }, 60); }, 400);
    };
    pre.src = src;
  }

  /* ---------- Sidopanel: välj färg & storlek + storleksguide ---------- */
  var M = null, cur = null, lastFocus = null;
  function sz(s) { s = String(s || '').toUpperCase().replace(/\s+/g, ''); return ({ XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' })[s] || s; }
  function build() {
    M = document.createElement('div');
    M.className = 'evq'; M.hidden = true;
    M.innerHTML =
      '<div class="evq-bg" data-close></div>' +
      '<aside class="evq-panel" role="dialog" aria-modal="true" aria-labelledby="evq-t" tabindex="-1">' +
        '<header class="evq-head"><div class="evq-head-txt"><div class="evq-vendor"></div><h3 class="evq-title" id="evq-t"></h3><div class="evq-price"></div></div>' +
          '<button type="button" class="evq-x" data-close aria-label="Stäng"><svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button></header>' +
        '<div class="evq-body">' +
          '<div class="evq-media"><div class="evq-img"><img alt=""></div><div class="evq-thumbs"></div></div>' +
          '<div class="evq-opts"></div>' +
          '<div class="evq-meta"><span class="evq-ship"><i></i><b></b><span></span></span><span class="evq-sku"></span></div>' +
          '<section class="evq-guide" id="evq-guide" hidden aria-labelledby="evq-guide-t"><div class="evq-guide-h"><h4 id="evq-guide-t">Storleksguide</h4></div>' +
            '<p class="evq-guide-sub"></p><div class="evq-table-wrap"><table class="evq-table"></table></div><p class="evq-guide-note"></p></section>' +
        '</div>' +
        '<footer class="evq-foot"><div class="evq-buy"><div class="evq-qty"><button type="button" data-q="-1" aria-label="Minska antal">−</button><input type="number" min="1" value="1" aria-label="Antal"><button type="button" data-q="1" aria-label="Öka antal">+</button></div>' +
          '<button type="button" class="evq-add"><span>Lägg i varukorg</span></button></div><a class="evq-link" href="#">Visa all produktinformation</a></footer>' +
      '</aside>';
    document.body.appendChild(M);
    M.addEventListener('click', onModalClick);
    M.addEventListener('keydown', onKey);
    $('.evq-qty input', M).addEventListener('change', function () { this.value = Math.max(1, parseInt(this.value, 10) || 1); });
  }
  function open(box, card) {
    var d = readData(box); if (!d) return;
    if (!M) build();
    lastFocus = document.activeElement;
    cur = { d: d, sel: [], card: card };
    var pre = d.v.find(function (x) { return x.id === d.pre; }) || d.v[0];
    d.opts.forEach(function (o, i) { cur.sel[i] = i === d.si ? null : pre.o[i]; });
    if (d.ci > -1 && box.dataset.color) cur.sel[d.ci] = box.dataset.color;
    if (d.si > -1 && d.opts[d.si].vals.length === 1) cur.sel[d.si] = d.opts[d.si].vals[0].v;

    $('.evq-vendor', M).textContent = d.b || '';
    $('.evq-title', M).textContent = d.t;
    $('.evq-link', M).href = d.u;
    $('.evq-qty input', M).value = 1;
    $('.evq-add', M).classList.remove('is-done', 'is-busy');

    var html = '';
    d.opts.forEach(function (o, i) {
      var isC = i === d.ci, isS = i === d.si;
      html += '<div class="evq-opt" data-i="' + i + '"><div class="evq-opt-label">' + esc(o.n) + ': <b class="evq-cur"></b>' +
        (isS ? '<span class="evq-opt-need">– välj ' + esc(o.n.toLowerCase()) + '</span>' : '') +
        (isS && d.st ? '<button type="button" class="evq-guide-link" data-guide>Storleksguide</button>' : '') +
        '</div><div class="evq-vals' + (isS ? ' is-sizes' : '') + '" role="radiogroup" aria-label="' + esc(o.n) + '">';
      o.vals.forEach(function (v) {
        html += isC
          ? '<button type="button" class="evq-chip" role="radio" data-v="' + esc(v.v) + '"' + (v.c ? ' style="--sw:' + esc(v.c) + '"' : '') + '><i aria-hidden="true"></i>' + esc(v.v) + '</button>'
          : '<button type="button" class="evq-btn" role="radio" data-v="' + esc(v.v) + '">' + esc(v.v) + '</button>';
      });
      html += '</div></div>';
    });
    $('.evq-opts', M).innerHTML = html;

    var th = '';
    d.imgs.forEach(function (src, i) { th += '<button type="button" class="evq-thumb" data-src="' + esc(src) + '" aria-label="Bild ' + (i + 1) + '"><img src="' + esc(src.replace('width=900', 'width=120')) + '" alt="" loading="lazy"></button>'; });
    $('.evq-thumbs', M).innerHTML = d.imgs.length > 1 ? th : '';
    var first = currentVariantImage() || d.imgs[0];
    var mi = $('.evq-img img', M); mi.src = first || ''; mi.dataset.src = first || ''; mi.classList.remove('is-out');

    buildGuide();
    M.classList.remove('is-hint');
    $('.evq-body', M).scrollTop = 0;
    update(false);
    M.hidden = false;
    document.documentElement.classList.add('evq-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { M.classList.add('is-open'); }); });
    setTimeout(function () { var f = M.querySelector('.evq-opt[data-need] .evq-btn:not(.is-na)') || $('.evq-x', M); f && f.focus({ preventScroll: true }); }, 80);
  }
  function buildGuide() {
    var d = cur.d, g = $('.evq-guide', M), st = d.st, m = st && st.m;
    if (!m || !m.rader || !m.rader.length || d.si < 0) { g.hidden = true; return; }
    var have = {}; d.opts[d.si].vals.forEach(function (v) { have[sz(v.v)] = v.v; });
    var h = '<thead><tr><th scope="col">Storlek</th>' + (m.kolumner || []).map(function (c) { return '<th scope="col">' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>';
    m.rader.forEach(function (r) {
      var real = have[sz(r[0])];
      h += '<tr data-size="' + esc(real || '') + '"' + (real ? ' tabindex="0"' : ' class="is-missing" title="Finns inte i den här modellen"') + '><th scope="row">' + esc(r[0]) + '</th>' +
        r.slice(1).map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
    });
    $('.evq-table', M).innerHTML = h + '</tbody>';
    $('.evq-guide-sub', M).textContent = (st.n ? st.n + ' · ' : '') + 'Kroppsmått i ' + (m.enhet || 'cm') + '. Klicka på en rad för att välja storleken.';
    $('.evq-guide-note', M).textContent = st.x || '';
    g.hidden = false;
  }
  function close() {
    if (!M || M.hidden) return;
    M.classList.remove('is-open');
    document.documentElement.classList.remove('evq-lock');
    setTimeout(function () { M.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function match() {
    var s = cur.sel; if (s.indexOf(null) !== -1) return null;
    return cur.d.v.find(function (v) { return v.o.every(function (x, j) { return x === s[j]; }); }) || null;
  }
  function currentVariantImage() {
    var d = cur.d, s = cur.sel;
    if (d.ci > -1) { var v = d.v.find(function (x) { return x.o[d.ci] === s[d.ci] && x.i; }); if (v) return v.i; }
    var m = match(); return m && m.i;
  }
  function showImage(src) {
    var mi = $('.evq-img img', M); if (!src || mi.dataset.src === src) return;
    mi.dataset.src = src;
    var pre = new Image();
    pre.onload = function () {
      if (mi.dataset.src !== src) return;
      mi.classList.add('is-out');
      setTimeout(function () { mi.src = src; mi.classList.remove('is-out'); }, 170);
    };
    pre.src = src;
    M.querySelectorAll('.evq-thumb').forEach(function (t) { t.classList.toggle('is-on', t.dataset.src === src); });
  }
  function update(animate) {
    var d = cur.d, s = cur.sel;
    M.querySelectorAll('.evq-opt').forEach(function (row) {
      var i = +row.dataset.i;
      row.querySelectorAll('[data-v]').forEach(function (b) {
        var on = s[i] === b.dataset.v;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
        var ok = d.v.some(function (v) { return v.a && v.o[i] === b.dataset.v && v.o.every(function (x, j) { return j === i || s[j] === null || x === s[j]; }); });
        b.classList.toggle('is-na', !ok);
        b.title = ok ? '' : 'Slut i den här kombinationen';
      });
      $('.evq-cur', row).textContent = s[i] || '';
      if (s[i] === null) row.setAttribute('data-need', ''); else row.removeAttribute('data-need');
    });
    if (d.si > -1) M.querySelectorAll('.evq-table tbody tr').forEach(function (tr) { tr.classList.toggle('is-on', !!tr.dataset.size && tr.dataset.size === s[d.si]); });
    var v = match();
    var cands = d.v.filter(function (x) { return x.o.every(function (o, j) { return s[j] === null || o === s[j]; }); });
    if (!cands.length) cands = d.v;
    var num = function (x) { return parseFloat(String(x.p).replace(/[^0-9,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) || 0; };
    var any = v || cands.reduce(function (m, x) { return num(x) < num(m) ? x : m; }, cands[0]);
    var varies = !v && cands.some(function (x) { return x.p !== any.p; });
    var priceHtml = (varies ? '<small>från</small> ' : '') + esc(any.p) + (any.c ? ' <s>' + esc(any.c) + '</s>' : '');
    var pe = $('.evq-price', M);
    if (pe.innerHTML !== priceHtml) { pe.innerHTML = priceHtml; if (animate) restart(pe, 'evq-flash'); }
    $('.evq-sku', M).textContent = v && v.s ? 'Art.nr ' + v.s : '';
    var ship = $('.evq-ship', M);
    if (v) {
      var inStock = v.q > 0;
      ship.hidden = false;
      ship.classList.toggle('is-order', !inStock);
      $('b', ship).textContent = !v.a ? 'Slut i lager' : (inStock ? 'I lager' : 'Beställningsvara');
      $('span', ship).textContent = !v.a ? '' : (inStock ? '· Leverans 1–2 dagar' : '· Leverans 3–7 dagar');
    } else { ship.hidden = true; }
    var add = $('.evq-add', M), lbl = $('span', add);
    add.classList.toggle('is-wait', !(v && v.a));
    lbl.textContent = !v ? (d.si > -1 && s[d.si] === null ? 'Välj ' + d.opts[d.si].n.toLowerCase() : 'Välj variant') : (v.a ? 'Lägg i varukorg' : 'Slut i lager');
    showImage(currentVariantImage());
  }
  function pick(i, val, el) {
    if (cur.sel[i] === val) return;
    cur.sel[i] = val;
    var row = M.querySelector('.evq-opt[data-i="' + i + '"]');
    if (row) { var c = $('.evq-cur', row); if (c) restart(c, 'evq-flash'); }
    M.classList.remove('is-hint');
    update(true);
  }
  function onModalClick(e) {
    if (e.target.closest('[data-close]')) { close(); return; }
    if (e.target.closest('[data-guide]')) { var g = $('#evq-guide', M); if (g) g.scrollIntoView({ block: 'start' }); return; }
    var tr = e.target.closest('.evq-table tbody tr');
    if (tr) { if (tr.dataset.size) pick(cur.d.si, tr.dataset.size); return; }
    var b = e.target.closest('[data-v]');
    if (b) { pick(+b.closest('.evq-opt').dataset.i, b.dataset.v, b); return; }
    var th = e.target.closest('.evq-thumb'); if (th) { showImage(th.dataset.src); return; }
    var q = e.target.closest('[data-q]');
    if (q) { var inp = $('.evq-qty input', M); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+q.dataset.q)); return; }
    if (e.target.closest('.evq-add')) addToCart();
  }
  function addToCart() {
    var v = match(), add = $('.evq-add', M);
    if (!v || !v.a) {
      restart(M, 'is-hint'); clearTimeout(M._t); M._t = setTimeout(function () { M.classList.remove('is-hint'); }, 2600);
      var need = M.querySelector('.evq-opt[data-need]'); if (need) need.scrollIntoView({ block: 'center' });
      return;
    }
    var qty = Math.max(1, parseInt($('.evq-qty input', M).value, 10) || 1);
    add.classList.add('is-busy');
    var done = function (ok) {
      add.classList.remove('is-busy');
      if (!ok) { $('span', add).textContent = 'Något gick fel – försök igen'; return; }
      add.classList.add('is-done'); $('span', add).textContent = 'Tillagd i varukorgen ✓';
      try { if (window.theme && theme.miniCart) { theme.miniCart.generateCart(); theme.miniCart.updateElements(); } } catch (e) {}
      setTimeout(close, 900);
    };
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    }).then(function (r) { done(r.ok); }).catch(function () { done(false); });
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    var tr = e.target.closest && e.target.closest('.evq-table tbody tr');
    if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (tr.dataset.size) pick(cur.d.si, tr.dataset.size); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(M.querySelectorAll('button, [href], input, tr[tabindex]'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  /* ---------- Koppla kortens knapp till popupen ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-grid-cart'); if (!b) return;
    var card = b.closest('.js-product-card'); if (!card) return;
    var box = card.querySelector('.ev-kv'); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(box, card);
  }, true);

  function all() {
    document.querySelectorAll('.ev-kv').forEach(function (box) {
      var card = box.closest('.js-product-card');
      if (card && card.querySelector('.ev-kv') !== box) { box.remove(); return; }
      initCard(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  var t = 0; new MutationObserver(function () { if (t) return; t = requestAnimationFrame(function () { t = 0; all(); }); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* ---------- Prisjakt "Billigast": skriptet laddas en gång per omgång nya kort (i stället för en gång per kort) ---------- */
(function () {
  function scan() {
    var fresh = 0;
    document.querySelectorAll('.prisjakt_cheapest').forEach(function (box) {
      if (box._pj) return; box._pj = 1; fresh++;
      var w = box.closest('.pj'), tag = w && w.querySelector('.cheap');
      if (tag) new MutationObserver(function () { if (box.childElementCount > 0) tag.hidden = false; }).observe(box, { childList: true, subtree: true });
    });
    if (fresh) { var s = document.createElement('script'); s.src = 'https://cdn.pji.nu/b2b/widgets/cheapest/index.js'; s.async = true; document.head.appendChild(s); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var t = 0; new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = 0; scan(); }, 250); }).observe(document.documentElement, { childList: true, subtree: true });
})();
